var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTools = function SvgTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "tools_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tools_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m24.187 26.282-6.297-6.298 2.107-2.107 6.298 6.297q.426.426.425 1.054 0 .628-.425 1.054a1.43 1.43 0 0 1-1.054.425 1.43 1.43 0 0 1-1.054-.425m-18.464 0a1.43 1.43 0 0 1-.426-1.054q0-.628.426-1.054l8.185-8.185-3.113-3.1a1.13 1.13 0 0 1-.83.329q-.504 0-.832-.329l-.651-.664v2.782q0 .416-.368.563-.367.148-.663-.147l-3.364-3.364q-.295-.295-.147-.663.147-.369.563-.368h2.782l-.618-.618a1.16 1.16 0 0 1-.362-.85q0-.49.362-.85L9.62 5.756a3.6 3.6 0 0 1 1.222-.825 3.67 3.67 0 0 1 2.432-.1q.501.16.977.51a.54.54 0 0 1 .251.422.58.58 0 0 1-.184.475l-2.149 2.149.733.733q.33.329.329.83 0 .504-.328.832l3.112 3.1 3.206-3.205a3.3 3.3 0 0 1-.326-.838 4 4 0 0 1-.103-.909q0-1.8 1.241-3.04 1.241-1.242 3.041-1.242.228 0 .417.01t.396.065a.5.5 0 0 1 .326.352.44.44 0 0 1-.118.46l-2.039 2.04a.6.6 0 0 0-.187.427q0 .241.187.428l1.518 1.518a.6.6 0 0 0 .428.188.6.6 0 0 0 .429-.188l2.038-2.038a.46.46 0 0 1 .46-.128.47.47 0 0 1 .353.336q.054.207.064.396.01.188.01.416 0 1.8-1.24 3.042-1.242 1.24-3.042 1.24-.476 0-.909-.092a2.7 2.7 0 0 1-.837-.336L7.831 26.282a1.43 1.43 0 0 1-1.054.425q-.628 0-1.054-.425"
  }))));
};
export default SvgTools;